import React from 'react';
import './PendingStatus.scss';

function PendingStatus(props) {
  const {
    view,
    pendingStatus: { title, subTitle },
  } = props;
  return (
    <div
      className={`pos-rel pending-item-status ${
        view === 'desktop'
          ? 'padding-t15 padding-b15 padding-r12 padding-l45 margin-l20 margin-r20'
          : 'pd-t12 pd-b12 pd-r12 pd-l50'
      }`}
      data-testid="pendingStatusWrapper"
    >
      <span className={`img-icon ${view === 'desktop' ? 'desktop' : 'mobile'} pos-abs`}>
        <img
          alt="pending status icon"
          aria-label="Pending Status Icon"
          src="https://static.lenskart.com/media/mobile/universal/assets/status-pending.png"
        />
      </span>
      <div className="pending-status display-flex align-items-center">
        <span className="flex-1 fs14 fsp14">
          <div className={`status-label ${view === 'desktop' ? 'fs16 font-bold' : ''}`}>
            {title}
          </div>
          <span
            className={`${
              view === 'desktop' ? 'fw700 text-color-grey' : 'fw500 text-color_pale_black'
            }`}
          >
            {subTitle}
          </span>
        </span>
      </div>
    </div>
  );
}
export default PendingStatus;
